import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ServiceBase } from "./service.base";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: 'root'
})
export class RegistrationsService extends ServiceBase {

  constructor(private http: HttpClient, authService: AuthService) {
    super(authService)
  }

  public getAllCountries(): Observable<Countries[]> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Country'
    const method: string = '/fetch-all-countries';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.get<Countries[]>(url, httpOptions);
  }
  public getAllStates(countryId: number): Observable<States[]> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Country'
    const method: string = `/country/${countryId}/states`;
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.get<States[]>(url, httpOptions);
  }
  public getAllCities(stateId: number): Observable<Cities[]> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Country'
    const method: string = `/state/${stateId}/cities`;
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.get<Cities[]>(url, httpOptions);
  }
}

export class Countries {
  id!: number;
  name!: string;
  iso3!: string;
  iso2!: string;
  numeric_code!: string;
  phonecode!: string;
  capital!: string;
  currency!: string;
  currency_name!: string;
  currency_symbol!: string;
  tld!: string;
  native!: string;
  region!: string;
  region_id!: number;
  subregion!: string;
  subregion_id!: number;
  nationality!: string;
  timezones!: string;
  translations!: string;
  latitude!: string;
  longitude!: string;
  emoji!: string;
  emojiU!: string;
  states!: string;
}

export class States {
  id!: number;
  name!: string;
  state_code!: string;
  latitude!: string;
  longitude!: string;
  type!: string;
  cities!: City[];
}

export class City {
  id!: number;
  name!: string;
  latitude!: string;
  longitude!: string;
}

export class Cities {
  id!: number;
  name!: string;
  latitude!: string;
  longitude!: string;
}